<template>
  <v-dialog
      :value="value"
      @input="$emit('input', $event)"
      max-width="420"
      scrollable
      content-class="fb-modal-dialog"
  >
    <div class="fb-modal">
      <div class="fb-modal__header">
        <v-icon small class="fb-modal__header-icon">mdi-gift-outline</v-icon>
        <span class="fb-modal__title">{{ $t('freeBets.modalTitle') }}</span>
        <button type="button" class="fb-modal__close" :aria-label="$t('close')" @click="$emit('input', false)">
          <v-icon small>mdi-close</v-icon>
        </button>
      </div>

      <div class="fb-modal__body">
        <template v-if="selectable && compatible.length">
          <span class="fb-modal__section">{{ $t('freeBets.compatibleSection') }}</span>
          <FreeBetCard
              v-for="token in compatible"
              :key="'c_' + token.tokenId"
              :token="token"
              selectable
              :selected="isSelected(token)"
              @toggle="toggle(token, $event)"
          ></FreeBetCard>
        </template>

        <template v-if="others.length">
          <span class="fb-modal__section" v-if="selectable && compatible.length">{{ $t('freeBets.otherSection') }}</span>
          <FreeBetCard
              v-for="token in others"
              :key="'o_' + token.tokenId"
              :token="token"
              :disabled="selectable"
          ></FreeBetCard>
        </template>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FreeBetCard from "@/components/right_widgets/FreeBetCard";

export default {
  name: "FreeBetsModal",
  components: { FreeBetCard },
  props: {
    value: { type: Boolean, default: false },
    // false nel carrello vuoto: le freebet si mostrano solo come elenco.
    selectable: { type: Boolean, default: true },
  },
  computed: {
    ...mapGetters({
      getAvailableFreeBets: "cart/getAvailableFreeBets",
      getCompatibleFreeBets: "cart/getCompatibleFreeBets",
      getSelectedFreeBet: "cart/getSelectedFreeBet",
    }),
    compatible() {
      return this.selectable ? this.getCompatibleFreeBets : [];
    },
    others() {
      const ids = new Set(this.compatible.map(t => t.tokenId));
      return (this.getAvailableFreeBets || []).filter(t => !ids.has(t.tokenId));
    },
  },
  methods: {
    ...mapActions({
      selectFreeBet: "cart/selectFreeBet",
    }),
    isSelected(token) {
      return !!this.getSelectedFreeBet && this.getSelectedFreeBet.tokenId === token.tokenId;
    },
    toggle(token, checked) {
      this.selectFreeBet(checked ? token.tokenId : null);
      // Scelta fatta: si torna al carrello con la freebet applicata.
      if (checked) this.$emit('input', false);
    },
  },
};
</script>

<style scoped>
.fb-modal {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  background: var(--bg-card);
  border-radius: 12px;
  overflow: hidden;
}

.fb-modal__header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid var(--hsla-1);
}

.fb-modal__header-icon {
  color: var(--cta-color) !important;
}

.fb-modal__title {
  flex: 1;
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-5xl);
}

.fb-modal__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: var(--sidebar);
  border: none;
  cursor: pointer;
}

.fb-modal__close .v-icon {
  color: var(--text-op-50-platform);
}

.fb-modal__body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 14px 14px;
  overflow-y: auto;
}

.fb-modal__section {
  margin-top: 4px;
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
  font-weight: 600;
  text-transform: uppercase;
}

.fb-modal__section:first-child {
  margin-top: 0;
}
</style>

<style>
.fb-modal-dialog {
  border-radius: 12px;
}
</style>
